<template>
    <section class="giving" id="how_to_give">
        <div class="giving__background-image">
            <img src="../assets/how-to-give-bg.jpg" alt />
        </div>
        <div class="wrapper">
            <div class="giving__inner">
                <h2><span class="icon icon-icon-give"></span>How to Give</h2>
                <div class="giving__intro">
                    <p>
                        To deliver on this vision we need the generosity, spirit
                        and support of the entire Kilkenny family. As we strive
                        to deliver the best educational experience and resources
                        for current and future generations, it is vital that we
                        have as much support as is possible.
                    </p>
                </div>
                <div class="giving__items">
                    <GivingItem
                        manual="1"
                        heading="A Once-off, or a Regular Contribution"
                        content="Gifts at all levels are needed and will be greatly appreciated, be they once-off donations or pledges to give over time. Please choose what suits your situation best."
                    >
                        <div class="pledge">
                            <h4>Please Pledge</h4>
                            <div class="giving-item__text">
                                <p>
                                    For all donations (once off or regular
                                    contribution) please download the pledge
                                    form, where you can choose the frequency and
                                    method of payment and return to the
                                    fundraising team here at Kilkenny.
                                </p>
                                <div class="links-container">
                                    <ButtonLink
                                        icon="download"
                                        title="Download Pledge Form"
                                        variant="primary"
                                        :link="pledgeFormURL"
                                    ></ButtonLink>
                                    <div class="text-links">
                                        <a :href="standingOrderURL">
                                            Standing Order Mandate
                                        </a>
                                        <a :href="enduringCertificateURL">
                                            CHY3 Enduring Certificate
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <h4>
                                For all cash or large donations please speak
                                with one of our lead fundraisers.
                            </h4>
                        </div>
                        <Team></Team>
                    </GivingItem>
                    <GivingItem
                        manual="2"
                        heading="Make an Online Donation "
                        content
                    >
                        <div class="giving-item__text">
                            <p>
                                If you would like to donate via our online
                                system, please click on the donate online link
                                which will bring you to our PayPal account.
                            </p>
                            <ButtonLink
                                icon="give"
                                title="Donate Online"
                                variant="secondary"
                                :link="donateOnlineURL"
                            ></ButtonLink>
                        </div>
                    </GivingItem>
                    <GivingItem
                        v-for="(item, index) in givings"
                        :key="item.id"
                        :numeral="index"
                        :heading="item.heading"
                        :content="item.content"
                    ></GivingItem>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import GivingItem from "@/components/GivingItem.vue"
import Team from "@/components/Team.vue"
export default {
    components: {
        GivingItem,
        Team,
    },
    data() {
        return {
            givings: null,
        }
    },
    created() {
        this.getGivingItems()
    },
    methods: {
        getGivingItems() {
            axios
                .get(`${this.$basePath}data/givings.json`)
                .then((result) => {
                    this.givings = result.data.givings
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.giving {
    padding-top: 0;
    padding-bottom: 8rem;
    background-color: #efefef;

    @include mobile {
        background: white;
        padding-bottom: 0;
    }

    &__inner {
        background: white;
        padding: 4rem;
        margin-top: -16rem;
        position: relative;

        @include mobile {
            margin-top: 0;
            padding: 4rem 0;
        }
    }

    &__intro {
        padding-bottom: 2rem;
        margin-bottom: 4rem;
        border-bottom: 1px solid #cccccc;
        padding-left: 4.5rem;

        p {
            max-width: 806px;
        }

        @include mobile {
            padding-left: 0;

            p {
                max-width: 100%;
            }
        }
    }
}

h2 {
    font-size: 3.375rem;

    @include mobile {
        font-size: 2.8rem;
    }

    span.icon {
        color: var(--primary_colour);
        margin-right: 1rem;
    }
}

h4 {
    color: var(--primary_font_colour);
    font-family: var(--title_font);
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.5;
    margin-top: 0.8rem;
}

.giving__background-image {
    width: 100%;
    line-height: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.links-container {
    .text-links {
        text-align: center;

        @include tablet-and-mobile {
            text-align: left;
        }

        @include tablet {
            display: flex;
        }

        a {
            display: block;
            margin-bottom: 0.5rem;
            color: var(--primary_font_colour);
            font-size: 0.875rem;
            font-weight: 600;
            text-decoration: underline;
            text-decoration-color: transparent;
            text-transform: uppercase;
            transition: 0.3s ease all;

            &:last-child {
                margin-bottom: 0;
            }

            &:hover {
                text-decoration-color: currentColor;
            }

            @include tablet {
                margin-right: 1rem;
            }

            @include tablet-and-mobile {
                text-decoration-color: currentColor;
            }
        }
    }
}
</style>
